// @todo Change URLs when shipping to gatsbyjs.com.

export default {
  description: `Gatsby is a React-based open source framework with performance, scalability and security built-in. Collaborate, build and deploy 1000x faster on Netlify.`,
  title: `Gatsby`,
  keywords: `gatsby, javascript, react, graphql, fast`,
  url: `https://www.gatsbyjs.com`,
  host: `www.gatsbyjs.com`,
  logo: `https://www.gatsbyjs.com/android-chrome-512x512.png`,
  image: `https://www.gatsbyjs.com/og-image.png`,
  twitter: `@gatsbyjs`,
  fbAppID: ``,
}
